import React from 'react';
import { Card, CardProps, Popover, Spin, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import GradientBorderBox from '@/components/Card/GradientBorderBox';
import styles from './index.less';

interface CardComponentProps extends CardProps {
  title?: string;
  children: React.ReactNode;
  hint?: string | React.ReactNode;
  className?: string;
  cardContentClassName?: string;
  loading?: boolean;
  gradientBorder?: boolean;
  mini?: boolean;
  noSpin?: boolean;
}

const CardComponent: React.FC<CardComponentProps> = ({
                                                       title,
                                                       children,
                                                       className,
                                                       cardContentClassName,
                                                       hint,
                                                       gradientBorder = false,
                                                       loading = false,
                                                       noSpin = false,
                                                       mini = false,
                                                       ...props
                                                     }) => {
  const Header = () =>
    title ? (
      <div className={styles.Card__header}>
        <Typography.Title level={2} className={styles.Card__header__title}>
          {title}
        </Typography.Title>
        {hint && (
          <Popover content={hint} trigger="click">
            <ExclamationCircleOutlined className={styles.Card__header__hint} />
          </Popover>
        )}
      </div>
    ) : null;

  const Content = (
    <section
      className={classNames(className, styles.Card, {
        [styles.mini]: mini,
        [styles.gradientBorderCardContent]: gradientBorder,
      })}
    >
      <Header />
      <Card {...props} className={classNames(styles.Card__content, cardContentClassName)}>
        {children}
      </Card>
    </section>
  );

  const WithSpin = noSpin ? Content : <Spin spinning={loading}>{Content}</Spin>;

  return gradientBorder ? <GradientBorderBox>{WithSpin}</GradientBorderBox> : WithSpin;
};

export default CardComponent;
